import React from 'react';
import '../../css/Footer.css';

interface FooterProps {
  variant: 'container' | 'admin';
  // Se agregan mas props de ser necesario.
}

const Footer: React.FC<FooterProps> = ({ variant }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`footer-${variant}`}>
      {variant === 'container' ? (
      <div className="content-wrap">
        <span className="copyright_text">DentalPuente © 2018-{currentYear} All Rights Reserved.</span>
      </div>
            ) : (
              <div className="content-wrap">
              <span className="copyright_text">DentalPuente © 2018-{currentYear} All Rights Reserved.</span>
            </div>
            )}
    </footer>
  );
};

export default Footer;
